<template lang="html">
  <div>
    <div class="page-header">
      <h1>
        <i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}
        {{ getConsecutive }}
      </h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="p-20 mb-10 card-base card-shadow--small ">
      <el-row :gutter="10">
        <el-col :span="8" :offset="0">
          <third-autocomplete-component/>
        </el-col>
        <el-col :span="3" :offset="0">
            <!-- :disabled="!editDocument" -->
          <el-date-picker
            v-model="date"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="Fecha">
          </el-date-picker>
        </el-col>
        <el-col :span="2" :offset="0">
          <el-input v-model="numDays" placeholder="Num. Días" size="normal" clearable @change=""></el-input>
        </el-col>
        <el-col :span="11" :offset="0">
          <div class="fr">
            <el-button 
              type="default" size="small" 
              @click="reset()" icon="el-icon-refresh-left">
                Cancelar
            </el-button>
            <list-log-component/>      
            <list-component/>
            <list-pending-component/>
            <el-button 
              :type="editDocument ? 'warning' : 'primary'" size="small" 
              @click="save()" icon="el-icon-check" 
              :loading="loading" :disabled="inventoryAuditId==null">
              {{ editDocument ? 'Actualizar' : 'Guardar' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <select-branch-component :showDialogSelectBranch="showDialogSelectBranch" @close="showDialogSelectBranch=false"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ListPendingComponent from "@/views/apps/inputOutputAdjust/ListPending.vue"
import ListLogComponent from "@/views/pages/administration/log/ListLog.vue"
import ThirdAutocompleteComponent from "@/views/pages/thirds/ThirdAutocomplete.vue"
import ListComponent from "./List.vue"
import SelectBranchComponent from "@/views/apps/inputOutputAdjust/SelectBranch.vue"
export default {
  components: { ListComponent, ListLogComponent, ListPendingComponent, ThirdAutocompleteComponent, SelectBranchComponent },
  data() {
    return {
      loading: false,
      showDialogSelectBranch: false
    };
  },
  created(){
    this['inputAndOutputAdjust/resetAction']()
  },
  computed: {
    ...mapGetters(['document', 'editDocument', 'inventoryAuditId']),
    numDays: {
      get() { return this.document.numDays },
      set(value) { this['inputAndOutputAdjust/SET_NUM_DAYS'](value) }
    },
    date: {
      get() { return this.document.date },
      set(value) { this['inputAndOutputAdjust/SET_DATE'](value) }
    },
    getConsecutive() {
      if(this.document.consecutive)
        return ' - ' + this.document.consecutive
    }
  },
  methods: {
    ...mapMutations([
      'inputAndOutputAdjust/SET_THIRD_ID', 'inputAndOutputAdjust/SET_NUM_DAYS', 
      'inputAndOutputAdjust/SET_DATE', 'inputAndOutputAdjust/SET_EDITING'
    ]),
    ...mapActions([
      'inputAndOutputAdjust/resetAction',
      'inputAndOutputAdjust/getPendingAction',
      'inputAndOutputAdjust/saveDocumentAction',
      'inputAndOutputAdjust/updateDocumentAction'
    ]),
    save() {
      if(this.$route.meta.typeDocument == 3){
        this.showDialogSelectBranch = true
        return 
      }
      if(this.editDocument){
        this['inputAndOutputAdjust/updateDocumentAction'](this.$route.meta.typeDocument)
      }else{
        this['inputAndOutputAdjust/saveDocumentAction']({
          type: this.$route.meta.type,
          typeDocument: this.$route.meta.typeDocument
        })
      }
    },
    reset() {
      this['inputAndOutputAdjust/resetAction']()
      this['inputAndOutputAdjust/getPendingAction'](this.$route.meta.typeDocument)
    },
  },
};
</script>

<style lang="css" scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 175px;
  }
</style>